import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { FirstUpperCase } from '../../../../services/Helpers/fonctions';
import { CgSearch } from "react-icons/cg";
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import Erreurs from '../../../Erreurs/Erreurs';
import Api from '../../../../services/Api';
const StepOne = ({ activeStep,setActiveStep,nextStep,setPaiement, paiement,handleInput }) => {
  const { register, handleSubmit, reset,trigger, setValue, formState: { errors } } = useForm({
    defaultValues: {
      typeDemandeur: paiement.typeDemandeur,
      demandeur:{
      fullName: paiement.demandeur.fullName,
      adresse: paiement.demandeur.adresse,
      telephone: paiement.demandeur.telephone,
      email: paiement.demandeur.email,
      nina: paiement.demandeur.nina,
      denominationSociete: paiement.demandeur.denominationSociete,
      rccm: paiement.demandeur.rccm,
      },
      infovehicule: {
        numeroChassis: paiement.infovehicule.numeroChassis,
        marque: paiement.infovehicule.marque,
        modele: paiement.infovehicule.modele,
        categorie: paiement.infovehicule.categorie,
        ptac: paiement.infovehicule.ptac,
        dateMiseCirculation: paiement.infovehicule.dateMiseCirculation,
        paysProvenance: paiement.infovehicule.paysProvenance,
        paysDestination: paiement.infovehicule.paysDestination,
        couleur: paiement.infovehicule.couleur,
        otherColor: paiement.infovehicule.otherColor,
        poidsTotalRoulant: paiement.infovehicule.poidsTotalRoulant,
        poidsAVide: paiement.infovehicule.poidsAVide,
        puissanceFiscale: paiement.infovehicule.puissanceFiscale,
        chargeUtile: paiement.infovehicule.chargeUtile
      }
    }
  });
 const [ natureDemandes,setNatureDemandes ] = useState(["particulier","concessionnaire","constructeur"]);
 const [ isLoading,setIsLoading ] = useRecoilState(loadingState);
 const [ erreurs,setErreurs ] = useState([]);
 const api = new Api();
  
  const handleSearch = async () => {
     try{
         setErreurs([]);setIsLoading(true);
        
         if( paiement.demandeur.nina.length > 0 ){
            const { status,errors, data } = await api.apiData("get",`/paiement/apc/nina?nina=${paiement.demandeur.nina}`);
           console.log(data);
            if( status === 200 ){
        
               if( data ){
                 
                  setValue("typeDemandeur",data.typeDemandeur,{ shouldValidate: true });
                  setValue("demandeur.fullName", data.fullName,{ shouldValidate: true });
                  setValue("demandeur.adresse", data.adresse,{ shouldValidate: true });
                  setValue("demandeur.telephone", data.telephone,{ shouldValidate: true });
                  setValue("demandeur.email", data.email,{ shouldValidate: true });
                  setValue("demandeur.nina", data.nina,{ shouldValidate: true });
                  setValue("demandeur.denominationSociete", data.denominationSociete,{ shouldValidate: true });
                  setValue("demandeur.rccm", data.rccm,{ shouldValidate: true });
                  // setValue("infovehicule.numeroChassis", data.numeroChassis.split(", "),{ shouldValidate: true });
                  // setValue("infovehicule.marque", data.marque_id,{ shouldValidate: true });
                  // setValue("infovehicule.modele", data.modele_id,{ shouldValidate: true });
                  // setValue("infovehicule.categorie", data.categorie_id,{ shouldValidate: true });
                  // setValue("infovehicule.ptac", data.ptac,{ shouldValidate: true });
                  // setValue("infovehicule.dateMiseCirculation", data.dateMiseCirculation,{ shouldValidate: true });
                  // setValue("infovehicule.paysProvenance", data.paysProvenance,{ shouldValidate: true });
                  // setValue("infovehicule.paysDestination", data.paysDestination,{ shouldValidate: true });
                  // setValue("infovehicule.couleur", data.couleur,{ shouldValidate: true });
                  // setValue("infovehicule.otherColor", data.otherColor ? "autre" : null,{ shouldValidate: true });
                  // setValue("infovehicule.poidsTotalRoulant", data.poidsTotalRoulant,{ shouldValidate: true });
                  // setValue("infovehicule.poidsAVide", data.poidsAVide,{ shouldValidate: true });
                  // setValue("infovehicule.puissanceFiscale", data.puissanceFiscale,{ shouldValidate: true });
                  // setValue("infovehicule.chargeUtile", data.chargeUtile,{ shouldValidate: true });

                  setPaiement(prev => ({
                    ...prev,
                    typeDemandeur: data.typeDemandeur,
                    demandeur: {
                      ...prev.demandeur,
                      telephone: data.telephone,
                      fullName: data.fullName,
                      email: data.email,
                      nina: data.nina,
                      denominationSociete: data.denominationSociete,
                      rccm: data.rccm,
                      adresse: data.adresse,
                    },
                    // infovehicule: {
                    //   ...prev.infovehicule,
                    //   marque: data.marque_id,
                    //   modele: data.modele_id,
                    //   categorie: data.categorie_id,
                    //   ptac: data.ptac,
                    //   numeroChassis: data.numeroChassis.split(", "),
                    //   dateMiseCirculation: data.dateMiseCirculation,
                    //   paysProvenance: data.paysProvenance,
                    //   paysDestination: data.paysDestination,
                    //   couleur: data.couleur,
                    //   otherColor: data.otherColor ? "autre" : null,
                    //   poidsTotalRoulant: data.poidsTotalRoulant,
                    //   poidsAVide: data.poidsAVide,
                    //   puissanceFiscale: data.puissanceFiscale,
                    //   chargeUtile: data.chargeUtile
                    // }
                  }));
                 // await trigger();
               }
               else {
               // Reset form when no data is found
                reset({
                  typeDemandeur: "",
                  demandeur: {
                    fullName: "",
                    adresse: "",
                    telephone: "",
                    email: "",
                    nina: paiement.demandeur.nina, // Keep the nina that was searched
                    denominationSociete: "",
                    rccm: ""
                  }
                });
                setPaiement(prev => ({
                  ...prev,
                  typeDemandeur: "",
                  demandeur: {
                    ...prev.demandeur,
                    fullName: "",
                    adresse: "",
                    telephone: "",
                    email: "",
                    denominationSociete: "",
                    rccm: ""
                  }
                }));
               }
            }
      
         }
     }
     catch(e){
      setErreurs([{ message: "Failed to load data" }]);
     }
     finally{
        setIsLoading(false)
     }
  }
  useEffect(() => {
    setValue("fullName", paiement.demandeur.fullName || "");
    setValue("telephone", paiement.demandeur.telephone || "");
  }, [paiement.demandeur.fullName,paiement.demandeur.telephone]);
   //console.log(paiement)
  return (
    <div className='step-component step-one'>
      <form onSubmit={handleSubmit(nextStep)}>
        <div className='input-group'>
           <label className='obligatoire'>Numéro de la pièce d'identité
           <div className="input-with-icon">
             <input 
               type='text'
               name='nina'
               value={paiement?.demandeur?.nina?.toUpperCase()}
               placeholder="Numéro de la pièce d'identité"
               {...register("nina", {
                required: "Le Numéro de la pièce d'identité est obligatoire",
                minLength: {
                value: 5, // Ajustez selon les règles locales
                message: "Le Numéro de la pièce d'identité doit contenir 5 caractères",
                },
                maxLength: {
                value: 15, // Ajustez si nécessaire
                message: "Le Numéro de la pièce d'identité ne doit pas dépasser 15 caractères",
                },
               
                onChange: (e) => handleInput(e), // Gestionnaire personnalisé
              })}
             /> 
             <span className="search-icon" onClick={handleSearch}>
                <CgSearch size={20} />
             </span>
            </div> 
             {errors.nina && (
                <>
                {["required","minLength", "maxLength"].map((errorType) => (
                    errors.nina?.type === errorType && (
                    <span key={errorType} className="error-msg">
                        {errors.nina.message}
                    </span>
                    )
                ))}
                </>
              )}
           </label>
           <label className='obligatoire'>Type de demandeur
             <select
               value={paiement?.typeDemandeur || ""} 
               name="typeDemandeur"
               {...register("typeDemandeur", {
               onChange: (e) => {
                  handleInput(e);
                  trigger("typeDemandeur");
               },
                  validate: (value) => value !== "" || "Ce champ est obligatoire.",
                })}
               >
               <option value="">---</option>  
              { natureDemandes.length > 0 && natureDemandes.map((nature,index) => <option key={index} value={nature}>{ nature.charAt(0).toUpperCase() + nature.slice(1)}</option>)}
             </select> 
             {errors.typeDemandeur && (
                 <span className="error-msg">{ errors.typeDemandeur.message}</span>
              )} 
           </label>  
        </div>
        <div className='input-group'>
          <label className='obligatoire'>Prénom et Nom { (paiement.typeDemandeur === 'particulier') ? " du client" : (paiement.typeDemandeur === "concessionnaire" || paiement.typeDemandeur  === "constructeur")? " du Representant" : ""}
               <input type='text' 
                  placeholder={`Prenom et nom ${ (paiement.typeDemandeur === 'particulier') ? " du client" : (paiement.typeDemandeur === "concessionnaire" || paiement.typeDemandeur  === "constructeur")? " du Representant" : ""}`}
                  value={ FirstUpperCase(paiement?.demandeur?.fullName)} 
                  name='fullName'
                  {...register("fullName", {
                   
                    required: true,
                    maxLength: 150,
                    minLength: 2,
                    onChange: (e) => {
                      handleInput(e);
                      setValue("fullName", e.target.value, { shouldValidate: true });
                    }
                  })}
               />  
                {errors.fullName && errors.fullName?.type === "required" && (
                    <span className="error-msg">Ce champ est obligatoire.</span>
                )}
                {errors.fullName && errors.fullName?.type === "minLength" && (
                 <span className="error-msg">
                    Ne peut pas être inférieur à 2 caractères.
                 </span>
                )}
               {errors.fullName && errors.fullName?.type === "maxLength" && (
                 <span className="error-msg">
                      Ne peut pas être supérieur à 150 caractères.
                    </span>
               )}
           </label>
          <label>Adresse
             <input type='text'
                name="adresse"
                placeholder='Adresse'
                value={paiement.demandeur.adresse || ""}
                {...register("adresse", {
                    onChange: (e) => {
                        handleInput(e);
                    } ,
                    maxLength: {
                        value:80,
                        message: "Maximum 80 caractères autorisés."
                    },
                    minLength: {
                        value:2,
                        message: "Minimum 2 caractères requis."
                    }
                })}
             />
            {errors.adresse && errors.adresse?.type === "maxLength" && (
                <span className="error-msg">{ errors.adresse.message }</span>
            )}
          </label>
        </div>
        <div className='input-group'>
          <label className='obligatoire'>Téléphone
              <input 
                 type="tel"
                 name="telephone"
                 placeholder="Numéro de téléphone (ex: 620000000)"
                 value={paiement.demandeur.telephone || ""}  // Note: Based on your state structure
                 {...register("telephone", {
                   required: "Le numéro de téléphone est obligatoire",
                   maxLength: {
                     value: 9,
                     message: "Maximum 9 chiffres autorisés"
                   },
                   minLength: {
                     value: 9,
                     message: "Minimum 9 chiffres requis"
                   },
                   pattern: {
                     value: /^6[0-9]{8}$/,
                     message: "Doit commencer par 6 et contenir 9 chiffres"
                   },
                   onChange: (e) => {
                      handleInput(e)
                   }
                 })}
              />  
              {errors.telephone && (
                  <>
                   {["required", "minLength", "maxLength", "pattern"].map((errorType) => (
                       errors.telephone?.type === errorType && (
                       <span key={errorType} className="error-msg">
                           {errors.telephone.message}
                       </span>
                      )
                    ))}
                 </>
              )}
          </label>
          <label>Email
             <input 
               type='text'
               name="email"
               placeholder="Email du client"
               value={paiement.demandeur.email || ""}
               {...register("email", {
                   onChange: (e) => {
                       handleInput(e);
                   } ,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Adresse email invalide"
                  }
               })}
             /> 
              {errors.email && (
                <>
                {["pattern","minLength", "maxLength"].map((errorType) => (
                    errors.email?.type === errorType && (
                    <span key={errorType} className="error-msg">
                        {errors.email.message}
                    </span>
                    )
                ))}
                </>
              )}
          </label>
        </div>
        {(paiement?.typeDemandeur !== "" && paiement?.typeDemandeur !== "particulier" &&
         <div className='input-group'>
           <label className='obligatoire'>Denomination du { paiement.typeDemandeur }
             <input type='text' 
               placeholder="Denomination de la société"
               value={paiement?.demandeur?.denominationSociete?.toUpperCase() || ""}
               {...register("denominationSociete", {
                onChange: (e) => {
                    handleInput(e);
                },
                required:"La denomination de la société est obligatoire.",
                maxLength: {
                    value:80,
                    message: "Maximum 80 caractères autorisés."
                },
                minLength: {
                    value:2,
                    message: "Minimum 2 caractères requis."
                }
              })}
             /> 
             {errors.denominationSociete && (
                <>
                {["required", "minLength", "maxLength", "pattern"].map((errorType) => (
                    errors.denominationSociete?.type === errorType && (
                    <span key={errorType} className="error-msg">
                        {errors.denominationSociete.message}
                    </span>
                    )
                ))}
                </>
              )}
           </label>
           <label className='obligatoire'>RCCM / NIF
               <input type='text'
                 name='rccm'
                 placeholder="Numero  du registre de commerce et du crédit mobilier"
                 value={paiement?.demandeur?.rccm?.toUpperCase() || ""}
                {...register("rccm", {
                    required: "Le RCCM est obligatoire",
                    minLength: {
                    value: 5, // Ajustez selon les règles locales
                    message: "Le RCCM doit contenir 5 caractères",
                    },
                    maxLength: {
                    value: 20, // Ajustez si nécessaire
                    message: "Le RCCM ne doit pas dépasser 20 caractères",
                    },
                   
                    onChange: (e) => handleInput(e), // Gestionnaire personnalisé
                })}
               /> 
               {errors.rccm && (
                <>
                {["required", "minLength", "maxLength"].map((errorType) => (
                    errors.rccm?.type === errorType && (
                    <span key={errorType} className="error-msg">
                        {errors.rccm.message}
                    </span>
                    )
                ))}
                </>
              )}
           </label>
         </div>
        )}
        <Erreurs validation={erreurs} />
        <div className="buttons">
            <button type="submit">Suivant</button>
        </div>
        </form>
    </div>    
  )
}

export default StepOne;
